import { PTPStatus } from "@portal/types/entities/ptp";
import { DisputeStatusConfig } from "./type";

const PTPStatusConfig: DisputeStatusConfig = {
  OPEN: {
    "--statusTextColor": "var(--red-6)",
    "--statusBorderColor": "var(--red-4)",
  },

  CLOSED: {
    "--statusTextColor": "var(--green-6)",
    "--statusBorderColor": "var(--green-4)",
  },
};

export function getPtpStatusConfig(status?: Exclude<PTPStatus, "ALL">) {
  if (!status) return
  return PTPStatusConfig[status];
}
